<div
  class="sg-toast__container"
  [@toastAnimation]="!disableAnimation ? animationState : null"
  [ngClass]="{'sg-toast__container--summary': data?.isSummaryToast, 'sg-toast__container--custom-height': height}"
  [style.max-width]="inline && maxWidth ? maxWidth : null"
  [style.height]="height">
  <div class="sg-toast__content">
    @if (!hideIcon) {
    <div class="sg-toast__icon">
      @if (type === 'wait') {
      <mat-spinner diameter="24" class="sg-ui-component"></mat-spinner>
      } @else {
      <mat-icon class="sg-ui-component">{{ getIconName() }}</mat-icon>
      }
    </div>
    }
    <div class="sg-toast__message">
      @if (inline) { @if (title) {
      <sg-text variant="sg-heading-small-bold" class="sg-toast__title">{{ title }}</sg-text>
      } @if (description) {
      <sg-text variant="sg-body-medium-regular" class="sg-toast__description" [sgTooltip]="descriptionTooltip || description" [showOnOverflow]="true">
        {{ description }}
      </sg-text>
      } @if (!description && data?.description) {
      <sg-text variant="sg-body-medium-regular" class="sg-toast__description" [sgTooltip]="descriptionTooltip || data.description" [showOnOverflow]="true">
        {{ data.description }}
      </sg-text>
      } @if (action) {
      <div class="sg-toast__action">
        @if (action.href) {
        <a [href]="action.href" [target]="action.target || '_self'" class="sg-toast__action-link" (click)="onActionClick()">
          <sg-text variant="sg-label-medium-regular">{{ action.text }}</sg-text>
        </a>
        } @else {
        <button class="sg-toast__action-button" (click)="onActionClick()">
          <sg-text variant="sg-label-medium-regular">{{ action.text }}</sg-text>
        </button>
        }
      </div>
      } } @else { @if (data?.isSummaryToast && data?.title) {
      <sg-text variant="sg-heading-small-bold" class="sg-toast__title">{{ data.title }}</sg-text>
      } @if (!data?.isSummaryToast && title) {
      <sg-text variant="sg-heading-small-bold" class="sg-toast__title">{{ title }}</sg-text>
      } @if (description) {
      <sg-text variant="sg-body-medium-regular" class="sg-toast__description" [sgTooltip]="descriptionTooltip || description" [showOnOverflow]="true">
        {{ description }}
      </sg-text>
      } @if (!description && data?.description) {
      <sg-text variant="sg-body-medium-regular" class="sg-toast__description" [sgTooltip]="descriptionTooltip || data.description" [showOnOverflow]="true">
        {{ data.description }}
      </sg-text>
      } @if (action) {
      <div class="sg-toast__action">
        @if (action.href) {
        <a [href]="action.href" [target]="action.target || '_self'" class="sg-toast__action-link" (click)="onActionClick()">
          <sg-text variant="sg-label-medium-regular">{{ action.text }}</sg-text>
        </a>
        } @else {
        <button class="sg-toast__action-button" (click)="onActionClick()">
          <sg-text variant="sg-label-medium-regular">{{ action.text }}</sg-text>
        </button>
        }
      </div>
      } }
    </div>
    @if (showCloseButton) {
    <div class="sg-toast__close">
      <sg-button
        icon="close"
        variant="ghost-secondary"
        size="small"
        (onClick)="data?.isSummaryToast ? hideStackedEffect() : dismiss()"
        data-test="close-toast-button"></sg-button>
    </div>
    }
  </div>
  @if (!preventAutoClose && showProgressBar) {
  <div class="sg-toast__progress">
    <div class="sg-toast__progress-bar" [@progressAnimation]="!disableAnimation ? {value: progressAnimationState, params: animationParams} : null"></div>
  </div>
  }
</div>
